import { capitalise1st, formatDate_D_MMM_YYYY, formatDate_MMMM_YYYY, formatFloat } from "../../../modules/utilities"
import { FORMATTING, JARGON } from "../../../modules/constants"
import { LEGEND } from "../../../modules/legends"
import { COUNTRY } from "../../../modules/Countries"

const { country, date, dobMonYear, float, local, percent, poundsM, title } = FORMATTING

export const getData = props => {
  const { id = 0, borderTop, color, label, tooltipTitle, type, valueTooltip, link, newTab } = props

  return {
    id,
    borderTop,
    color,
    label: label ?? LEGEND[id].label ?? "",
    tooltipTitle: tooltipTitle ?? LEGEND[id].tooltipTitle ?? "",
    type,
    value: formatValue(props),
    valueTooltip,
    link,
    newTab
  }
}

const formatValue = ({ type, value }) => {
  // console.log('value:',value)
  switch (type) {

    case date:
      return formatDate_D_MMM_YYYY(value)

    case dobMonYear:
      return formatDate_MMMM_YYYY(value)

    case country:
      return COUNTRY[value].name

    case percent:
      return `${value}%`

    case float:
      return formatFloat(value, 1)

    case local:
      return value ? value.toLocaleString() : "?"

    case poundsM:
      return value ? `£${value.toLocaleString()}M` : "?"

    case title:
      return capitalise1st(value)

    default:
      // If value is null or an empty array return 'n/a' else return value
      return value === null || (Array.isArray(value) && value.length === 0)
        ? JARGON.UNKNOWN
        : value
  }
}
